module.exports = __webpack_public_path__ + "img/reentry-white.2acc660a.png";